import { apiSlice } from "..";
import { getToken } from "shared/utils/getToken";

const provaResultadoSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    importarProvaResultado: build.mutation<void, File>({
      query: (arquivo) => {
        const formData = new FormData();
        formData.append("arquivo", arquivo);

        return {
          url: "prova-resultado/importar",
          method: "POST",
          headers: { Authorization: `Bearer ${getToken()}` },
          body: formData,
        };
      },
      invalidatesTags: ["Inscricoes"],
    }),
  }),
  overrideExisting: false,
});

export const { useImportarProvaResultadoMutation } = provaResultadoSlice;
